module.exports = __webpack_public_path__ + "static/media/pdf.13fe1021.svg";